import SlideFrame from "./_SlideFrame";

const items = [
  { n: "01", t: "Regulatory-aligned practices", d: "Servicing workflows built to meet institutional and regulatory standards from day one." },
  { n: "02", t: "Audit-ready reporting", d: "Comprehensive reporting infrastructure that satisfies examiner and partner requirements." },
  { n: "03", t: "Data security & borrower protection", d: "Encrypted workflows and strict data governance protect borrowers and partners alike." },
  { n: "04", t: "QA, monitoring & oversight", d: "Continuous quality assurance and operational monitoring ensure consistent performance." },
];

export default function SlideComplianceReadiness() {
  return (
    <SlideFrame tag="06 · Compliance">
      <p className="overline mb-6">Built-in readiness</p>
      <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95] font-medium max-w-4xl">
        Compliance is <em className="italic">table stakes</em>. We start there.
      </h2>

      <div className="mt-14 grid md:grid-cols-2 gap-px bg-foreground/20 border border-foreground/20">
        {items.map((i) => (
          <div key={i.n} className="bg-background p-8 md:p-10">
            <span className="font-mono-data text-sm text-muted-foreground">{i.n}</span>
            <h3 className="font-display text-2xl md:text-3xl mt-3 leading-tight">{i.t}</h3>
            <p className="mt-4 text-sm text-muted-foreground leading-relaxed">{i.d}</p>
          </div>
        ))}
      </div>
    </SlideFrame>
  );
}
